<template>
  <div
    class="standard-flex-box"
    :style="`
      ${max_height?`max-height: ${max_height};`:''}
      ${height?`height: ${height};`:''}
      ${line_height?`line-height: ${line_height};`:''}
      ${width?`width: ${width};`:''}
      ${direction?`flex-direction: ${direction};`:''}
      ${justify_content?`justify-content: ${justify_content};`:''}
      ${gap?`gap: ${gap};`:''}
      ${align_items?`align-items: ${align_items};`:''}
      flex-wrap: ${no_wrap?'nowrap':'wrap'};
      align-content: ${align_content?align_content:'flex-start'};
    `"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: [
      'max_height',
      'height',
      'line_height',
      'width',
      'direction',
      'no_wrap',
      'align_content',
      'justify_content',
      'align_items',
      'gap'
    ],
  }
</script>
<style>
  .standard-flex-box {
    display: flex;
    overflow-y: auto;
    overflow-x: visible;
    scroll-behavior: smooth;
    transition: width ease-in-out 0.2s, height ease-in-out 0.2s
  }
</style>
